import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import {
  getMenuItemNamesMediumColor,
  getMenuItemNamesLightColor,
  getMenuItemNamesColor
} from 'styles/helpers/getThemeStyles';

const RadioButton = styled(Box)(({ isSelected, theme }) => ({
  borderStyle: 'solid',
  borderWidth: '0.125rem',
  borderRadius: 4,
  borderColor: isSelected
    ? getMenuItemNamesColor(theme)
    : getMenuItemNamesLightColor(theme),
  '&:hover': {
    borderColor: isSelected
      ? getMenuItemNamesColor(theme)
      : getMenuItemNamesLightColor(theme)
  },
  flexGrow: 1,
  width: '100%',
  padding: '0.5rem',
  marginRight: '1rem',
  marginLeft: '1rem',
  marginTop: '0.75rem',
  marginBottom: '0.75rem'
}));

const LabelTypography = styled(Typography)(({ theme }) => ({
  color: getMenuItemNamesMediumColor(theme),
  fontSize: '16px'
}));

const GroupOrderSpendingOptionLabel = ({ option, isSelected }) => (
  <RadioButton
    flexDirection="row"
    justifyContent="space-between"
    alignItems="center"
    isSelected={isSelected}
  >
    <LabelTypography align="center">{option.label}</LabelTypography>
  </RadioButton>
);

GroupOrderSpendingOptionLabel.propTypes = {
  option: PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired,
  isSelected: PropTypes.bool.isRequired
};

export default GroupOrderSpendingOptionLabel;
